import { Children } from 'react';
import getElementName from './getElementName.js';
const groupByType = function (children) {
  let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let rest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rest';
  const typeNames = types.map(type => typeof type === 'string' ? type : type.name);
  return Children.toArray(children).reduce((acc, child) => {
    const elementName = getElementName(child);
    const key = elementName !== null && typeNames.includes(elementName) ? elementName : rest;
    if (typeof acc[key] === 'undefined') {
      acc[key] = [];
    }
    acc[key] = [...acc[key], child];
    return acc;
  }, {});
};
export default groupByType;